// extracted by mini-css-extract-plugin
export var growableInput = "_64-0";
export var tagContainer = "_64-2";
export var textInput = "_64-1";